module.exports = __webpack_public_path__ + "static/img_0545-e57f99135f01c89a4fc2a0ec48ae8e97.webp";